import { useTranslation } from "react-i18next";

const VARIANTS = {
  // PO statuses
  pending_approval: { bg: "bg-amber-100", text: "text-amber-800", key: "status.pending_approval" },
  approved: { bg: "bg-emerald-100", text: "text-emerald-800", key: "status.approved" },
  rejected: { bg: "bg-red-100", text: "text-red-800", key: "status.rejected" },
  invoiced: { bg: "bg-blue-100", text: "text-blue-800", key: "status.invoiced" },
  received: { bg: "bg-slate-100", text: "text-slate-800", key: "status.received" },
  cancelled: { bg: "bg-slate-100", text: "text-slate-600", key: "status.cancelled" },
  // Compras externas
  pendiente_vobo_compras: { bg: "bg-amber-100", text: "text-amber-800", label: "Pend. VoBo Compras" },
  pendiente_vobo_direccion: { bg: "bg-orange-100", text: "text-orange-800", label: "Pend. VoBo Dirección" },
  aprobada: { bg: "bg-emerald-100", text: "text-emerald-800", label: "Aprobada" },
  rechazada: { bg: "bg-red-100", text: "text-red-800", label: "Rechazada" },
  // Supplier statuses
  approved_supplier: { bg: "bg-emerald-100", text: "text-emerald-800", key: "status.approved_supplier" },
  suspended: { bg: "bg-slate-200", text: "text-slate-700", key: "status.suspended" },
  pending_documents: { bg: "bg-orange-100", text: "text-orange-800", key: "status.pending_documents" },
  // Invoice
  validated: { bg: "bg-blue-100", text: "text-blue-800", key: "status.validated" },
  scheduled_for_payment: { bg: "bg-purple-100", text: "text-purple-800", key: "status.scheduled_for_payment" },
  paid: { bg: "bg-emerald-100", text: "text-emerald-800", key: "status.paid" },
  // Alert severities
  info: { bg: "bg-blue-100", text: "text-blue-800", key: "status.info" },
  warning: { bg: "bg-amber-100", text: "text-amber-800", key: "status.warning" },
  critical: { bg: "bg-red-100", text: "text-red-800", key: "status.critical" },
};

export default function StatusBadge({ status, label, customClass = "" }) {
  const { t } = useTranslation();
  const v = VARIANTS[status] || { bg: "bg-slate-100", text: "text-slate-800", key: null };
  const text = label || (v.key ? t(v.key) : v.label || status);
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-semibold ${v.bg} ${v.text} ${customClass}`}
    >
      {text}
    </span>
  );
}
